import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  clearCompanyUserConfigurations,
  getCompanyUserConfigurations,
} from '../../../../actions';
import {
  COMPANY_USER_CONFIGURATION_PATH,
  NEW_COMPANY_USER_CONFIGURATION_PATH,
} from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { COMPANY_USER_CONFIGURATION_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

export class CompanyUserConfigurations extends Component {
  componentWillUnmount() {
    this.props.dispatchClearCompanyUserConfigurations();
  }

  render() {
    const {
      configurations,
      loading,
      dispatchGetCompanyUserConfigurations,
      breadcrumbs,
    } = this.props;
    const data = configurations.get('content') || [];
    const pages = configurations.get('totalPages') || null;
    const defaultPageSize = configurations.get('size') || DEFAULT_PAGE_SIZE;

    return (
      <ModuleList
        title="Configuraciones de Usuario"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_COMPANY_USER_CONFIGURATION_PATH}
        tableStructure={{
          columns: COMPANY_USER_CONFIGURATION_COLUMNS,
          data,
          pages,
          defaultPageSize,
          filterable: true,
          fetchData: dispatchGetCompanyUserConfigurations,
          modelPath: COMPANY_USER_CONFIGURATION_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    );
  }
}

const mapDispatchToProps = {
  dispatchGetCompanyUserConfigurations: getCompanyUserConfigurations,
  dispatchClearCompanyUserConfigurations: clearCompanyUserConfigurations,
};

const mapStateToProps = ({ ContractUnit }) => ({
  breadcrumbs: [
    ...ContractUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Configuraciones de Usuario',
      href: COMPANY_USER_CONFIGURATION_PATH,
    },
  ],
  configurations: ContractUnit.CompanyUserConfiguration.getIn([
    'all',
    'content',
  ]),
  loading: ContractUnit.CompanyUserConfiguration.getIn(['all', 'loading']),
});

CompanyUserConfigurations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  configurations: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetCompanyUserConfigurations: PropTypes.func.isRequired,
  dispatchClearCompanyUserConfigurations: PropTypes.func.isRequired,
};

CompanyUserConfigurations.defaultProps = {
  configurations: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyUserConfigurations);
